module.exports = __webpack_public_path__ + "img/settings-button.f2ceb6f3.svg";